// src/db/skills.js

const skillList = [
    {
      title: "Languages",
      skills: [
        { name: "C#", imageUrlName: "csharp" },
        { name: "JavaScript", imageUrlName: "javascript" },
        { name: "Java", imageUrlName: "java" },
        { name: "Python", imageUrlName: "python" },
      ],
    },
    {
      title: "Web Development",
      skills: [
        { name: "React.js", imageUrlName: "react" },
        { name: "Node.js", imageUrlName: "nodejs" },
        { name: "HTML", imageUrlName: "html5" },
        { name: "CSS", imageUrlName: "css3" },
        { name: "Bootstrap", imageUrlName: "bootstrap" },
        { name: "Redux", imageUrlName: "redux" },
        { name: "Tailwind", imageUrlName: "tailwind" },
        { name: "JavaScript", imageUrlName: "javascript" },
        { name: "TypeScript", imageUrlName: "typescript" },
      ],
    },
    {
      title: "Cloud and Database",
      skills: [
        { name: "AWS", imageUrlName: "aws" },
        { name: "Azure", imageUrlName: "azure" },
        { name: "Azure DevOps", imageUrlName: "azuredevops" },
        { name: "MySQL", imageUrlName: "mysql" },
        { name: "MongoDB", imageUrlName: "mongodb" },
        { name: "SQLite", imageUrlName: "sqlite" },
      ],
    },
    {
      title: "Frameworks",
      skills: [
        { name: "Xamarin.Forms", imageUrlName: "xamarin" },
        { name: "Spring", imageUrlName: "spring" },
        { name: "Junit", imageUrlName: "junit5" },
        { name: "Dotnet", imageUrlName: "dotnet" },
      ],
    },
  ];
  
  export default skillList;
  